import { useRouter } from 'next/router';
import { ProductItem } from '@/lib/types/api';
import useTranslation from 'next-translate/useTranslation';
import { displayMeasuringUnits } from '@/lib/data-transformer/gindumacUtils';
import { ProductDataListItem } from './ProductDataListItem';
import { trim } from 'lodash-es';

// TODO: refactor this incompreensible code with e2e tests to ensure that is still the same data shown
export function TechnicalInformation({ product }: { product: ProductItem }) {
  const { t } = useTranslation('products');
  const { t: productst } = useTranslation('products');
  const list = {
    'Pickup Address': ['Address'],
    Overview: ['Brand', 'Model'],
    'General Data': ['Type of drive'],
    'Control Unit': ['Brand', 'Model', 'Interface'],
    'Main Drive': ['Tool taper', 'Plasma brand', 'Illumination', 'Laser brand'],
  };
  const { locale } = useRouter();
  return (
    <div className='mt-20 px-4' data-testid='technical-info'>
      {/* TODO: remove those useless divs */}
      <div className=''>
        <div className=''>
          <h2 className='mb-4' data-testid='technical-info-title'>
            {t('DETAIL_PAGE_TECHNICAL_TITLE') +
              ' - ' +
              product.brand.name +
              ' ' +
              product.model}
          </h2>
          {product.technical_information.map((tech_info, tech_info_index) => (
            <div className='title-technical-information' key={tech_info_index}>
              {tech_info.name !== 'Additional Equipment' &&
                tech_info.details.length != 0 && (
                  <p className='border-b-[1px] py-4 font-secondary text-xl uppercase text-brand-500'>
                    {productst(`${tech_info.name}`)}
                  </p>
                )}
              <ul className='mb-12 mt-4 columns-1 md:columns-2'>
                {tech_info.details.map((detail, indexDetail) => {
                  const splitAndRejoin = (text: string) => {
                    const splitText = text.split(',');
                    const translatedContent = splitText.map((item) => {
                      return t(`${item.trim()}`);
                    });
                    return translatedContent.join(', ');
                  };
                  const mesasureUnit = displayMeasuringUnits(
                    detail.title,
                    detail.content
                  );
                  let standardisedContent = detail.content;
                  if (
                    detail.content != '' &&
                    tech_info?.title &&
                    list[tech_info?.title] &&
                    list[tech_info?.title].length > 0
                  ) {
                    list[tech_info.title].forEach((item) => {
                      if (item === tech_info.name) {
                        standardisedContent =
                          splitAndRejoin(standardisedContent);
                      }
                    });
                  }

                  if (
                    tech_info.name.toLowerCase() === 'additional equipment' &&
                    detail.content != ''
                  ) {
                    return null;
                  }

                  if (detail.content != '' && tech_info.name === 'Movement') {
                    const splitTitle = detail.title.split(' ');
                    const title1 = splitTitle[0];
                    const title2 = splitTitle
                      .splice(1, splitTitle.length)
                      .join(' ');
                    const hasToInvert = locale != 'es-ES' && locale != 'it-IT';
                    return (
                      <ProductDataListItem
                        title={
                          hasToInvert
                            ? productst(title1) + ' ' + productst(title2)
                            : productst(title2) + ' ' + productst(title1)
                        }
                        subtitle={standardisedContent + ' ' + mesasureUnit}
                        key={indexDetail}
                      />
                    );
                  }
                  if (
                    detail.content !== '' &&
                    ((tech_info.name === 'Main Drive' &&
                      detail.title === 'Max taper angle') ||
                      (tech_info.name === 'Main Drive' &&
                        detail.title === 'Camera') ||
                      (tech_info.name === 'Main Drive' &&
                        detail.title === 'Illumination') ||
                      (tech_info.name === 'General Data' &&
                        detail.title === 'Type of drive') ||
                      (tech_info.name === 'General Data' &&
                        detail.title === 'Closure'))
                  ) {
                    if (detail.content.indexOf(',') !== -1) {
                      const standardisedContent = detail.content.replace(
                        '/',
                        ','
                      );
                      const splitContent = standardisedContent.split(',');
                      const translatedContent = splitContent.map((item) => {
                        return t(`${item.trim()}`);
                      });
                      detail.content = translatedContent.join(', ');
                    }
                    return (
                      <li key={indexDetail} className='uppercase text-gray-600'>
                        <strong>{t(`${detail.title}`)}: </strong>
                        {t(`${standardisedContent}`)}
                      </li>
                    );
                  }
                  if (
                    detail.content !== '' &&
                    ((tech_info.name === 'Turret' &&
                      detail.title === 'Rotating tools') ||
                      (tech_info.name === 'Media' &&
                        (detail.title === 'Chip conveyor' ||
                          detail.title === 'Internal cooling')))
                  ) {
                    return (
                      <ProductDataListItem
                        title={t(trim(detail.title))}
                        key={indexDetail}
                        subtitle={t(standardisedContent)}
                      />
                    );
                  }
                  if (
                    detail.content !== '' &&
                    tech_info.name === 'Machine Specific Data' &&
                    detail.title === 'Laser turbine details'
                  ) {
                    return (
                      <ProductDataListItem
                        title={t(trim(detail.title))}
                        key={indexDetail}
                        subtitle={t(standardisedContent)}
                      />
                    );
                  } else if (
                    detail.content !== '' &&
                    tech_info.name === 'Control Unit' &&
                    (detail.title === 'Interface' ||
                      detail.title === 'Remote Control' ||
                      detail.title === 'CNC language customizable')
                  ) {
                    if (
                      detail.content.indexOf(',') !== -1 ||
                      detail.content.indexOf('/') !== -1
                    ) {
                      const standardisedContent = detail.content.replace(
                        '/',
                        ','
                      );
                      const splitContent = standardisedContent.split(',');
                      const translatedContent = splitContent.map((item) => {
                        return t(`${item.trim()}`);
                      });
                      detail.content = translatedContent.join(', ');
                    }
                    return (
                      <ProductDataListItem
                        title={t(trim(detail.title))}
                        key={indexDetail}
                        subtitle={t(detail.content)}
                      />
                    );
                  } else if (detail.content != '') {
                    return (
                      <ProductDataListItem
                        title={t(trim(detail.title))}
                        key={indexDetail}
                        subtitle={standardisedContent + ' ' + mesasureUnit}
                      />
                    );
                  } else {
                    return null;
                  }
                })}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
